import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | timeout | error
  const [orderNum, setOrderNum] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setOrderNum(data.order_num);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "failed") { setState("error"); return; }
      } catch { /* keep polling */ }
      if (attempts >= 8) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-28 text-center">
      {state === "checking" && (
        <div data-testid="payment-checking">
          <Loader2 className="mx-auto text-ape-red mb-6 animate-spin" size={56} />
          <h1 className="font-display text-4xl tracking-tight">CONFIRMING PAYMENT…</h1>
          <p className="text-ape-muted mt-3">Hang tight while we verify your transaction.</p>
        </div>
      )}
      {state === "paid" && (
        <div data-testid="payment-paid">
          <CheckCircle2 className="mx-auto text-green-500 mb-6" size={64} />
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight">PAYMENT COMPLETE</h1>
          <p className="text-ape-muted mt-4">{orderNum && <>Order <span className="font-mono2 text-white">{orderNum}</span> is paid and confirmed. </>}Your discreet shipment is being prepared. Stay relentless.</p>
          <Link to="/account" className="inline-flex mt-8 bg-ape-red hover:bg-ape-redhover text-white font-head uppercase tracking-widest px-8 py-4 transition-colors duration-150" data-testid="success-orders-btn">View My Orders</Link>
        </div>
      )}
      {(state === "timeout" || state === "error") && (
        <div data-testid="payment-pending">
          <XCircle className="mx-auto text-ape-red mb-6" size={56} />
          <h1 className="font-display text-4xl tracking-tight">{state === "timeout" ? "STILL PROCESSING" : "PAYMENT ISSUE"}</h1>
          <p className="text-ape-muted mt-4">{state === "timeout" ? "Your payment is taking a moment to confirm. Check your order status in your account shortly." : "We couldn't confirm this payment. If you were charged, contact support."}</p>
          <Link to="/account" className="inline-flex mt-8 border-2 border-ape-red text-ape-red hover:bg-ape-red hover:text-white font-head uppercase tracking-widest px-8 py-4 transition-colors duration-150">View My Orders</Link>
        </div>
      )}
    </div>
  );
}
